(function () {
  function isComplianceChecked(formEl) {
    const trigger = formEl.querySelector(
      ".gfield.compliance_only_trigger input[type='checkbox']"
    );
    return !!trigger && trigger.checked;
  }

  function getSectionFields(sectionEl) {
    const fields = [];
    let node = sectionEl.nextElementSibling;

    while (node) {
      // Stop at next section
      if (node.classList.contains("gsection")) break;

      // Stop before page footer/buttons
      if (
        node.classList.contains("gform_page_footer") ||
        node.classList.contains("gform_footer")
      ) {
        break;
      }

      fields.push(node);
      node = node.nextElementSibling;
    }

    return fields;
  }

  function setSectionExpanded(sectionEl, expanded) {
    const btn = sectionEl.querySelector(".gf-acc-toggle");
    if (btn) {
      btn.setAttribute("aria-expanded", expanded ? "true" : "false");
    }

    const fields = getSectionFields(sectionEl);

    fields.forEach((field) => {
      // Respect GF hidden fields when expanded
      if (expanded) {
        field.hidden = false;
      } else {
        field.hidden = true;
      }
    });
  }

  function toggleSection(sectionEl) {
    const btn = sectionEl.querySelector(".gf-acc-toggle");
    if (!btn) return;

    const expanded = btn.getAttribute("aria-expanded") === "true";
    setSectionExpanded(sectionEl, !expanded);
  }

  function initSection(sectionEl, compliance) {
    if (sectionEl.dataset.gfAccordionInit === "1") return;
    sectionEl.dataset.gfAccordionInit = "1";

    const isBusiness = sectionEl.classList.contains("gf-acc-business");

    // If compliance_only is checked, Business Info should stay open and not collapsible
    if (compliance && isBusiness) {
      return;
    }

    if (sectionEl.offsetParent === null) return;

    const titleEl = sectionEl.querySelector(".gsection_title");
    if (!titleEl) return;

    const titleText = titleEl.textContent.trim();

    const btn = document.createElement("button");
    btn.type = "button";
    btn.className = "gf-acc-toggle";
    btn.setAttribute("aria-expanded", "false");
    btn.innerHTML = `
      <span class="gf-acc-toggle__text">${titleText}</span>
    `;

    titleEl.textContent = "";
    titleEl.appendChild(btn);

    btn.addEventListener("click", () => toggleSection(sectionEl));

    // Start collapsed
    setSectionExpanded(sectionEl, false);
  }

  function refreshSectionVisibility(formEl) {
    const compliance = isComplianceChecked(formEl);
    const sections = Array.from(formEl.querySelectorAll(".gsection.gf-acc-section"));

    sections.forEach((sectionEl) => {
      const isBusiness = sectionEl.classList.contains("gf-acc-business");
      const btn = sectionEl.querySelector(".gf-acc-toggle");

      // Compliance checked: Business section should be open and not collapsible
      if (compliance && isBusiness) {
        const fields = getSectionFields(sectionEl);

        fields.forEach((field) => {
          field.hidden = false;
        });

        if (btn) {
          btn.remove();
          const titleEl = sectionEl.querySelector(".gsection_title");
          if (titleEl && !titleEl.textContent.trim()) {
            titleEl.textContent = "Business Information";
          }
        }

        return;
      }

      // If already initialized, keep current open/closed state
      if (btn) {
        const expanded = btn.getAttribute("aria-expanded") === "true";
        const fields = getSectionFields(sectionEl);

        fields.forEach((field) => {
          field.hidden = !expanded;
        });
      }
    });
  }

  function buildAccordionForForm(formId) {
    const formEl = document.querySelector(`#gform_${formId}`);
    if (!formEl) return;

    const compliance = isComplianceChecked(formEl);
    const sections = Array.from(formEl.querySelectorAll(".gsection.gf-acc-section"));
    if (!sections.length) return;

    sections.forEach((sectionEl) => initSection(sectionEl, compliance));
    refreshSectionVisibility(formEl);
  }

  function initAllGFForms() {
    document.querySelectorAll("form[id^='gform_']").forEach((formEl) => {
      const match = formEl.id.match(/^gform_(\d+)$/);
      if (match) {
        buildAccordionForForm(match[1]);
      }
    });
  }

  function boot() {
    initAllGFForms();

    if (window.jQuery) {
      window.jQuery(document).on(
        "gform_post_render gform_page_loaded gform_post_conditional_logic",
        function (event, formId) {
          buildAccordionForForm(formId);
        }
      );
    } else {
      const obs = new MutationObserver(() => initAllGFForms());
      obs.observe(document.body, { childList: true, subtree: true });
    }

    // No height recalculation needed, but this is harmless if the form reflows on resize
    window.addEventListener("resize", initAllGFForms);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();